import { render, staticRenderFns } from "./DuocSpecificationTable.vue?vue&type=template&id=a1b44352&scoped=true"
import script from "./DuocSpecificationTable.vue?vue&type=script&lang=js"
export * from "./DuocSpecificationTable.vue?vue&type=script&lang=js"
import style0 from "./DuocSpecificationTable.vue?vue&type=style&index=0&id=a1b44352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b44352",
  null
  
)

export default component.exports